import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "../styles/Blog.css";

const blogPosts = [
  {
    id: "1",
    title: "Mi último libro: El número de poder de tu alma",
    content: "Querido lector y habitante de uno de estos universos, te pediré que recuerdes al leer este libro que Doina 28 no puede saber todo, porque es simplemente un alma que recordó, y que tú también lo harás.<br><br> Y tú y todos, con vuestros recuerdos, conseguiréis que nunca pare la escritura de este libro, y con el paso del tiempo nadie ni nada podrá escribir su final……Doina 28, un alma que descubrió que no existe el tiempo pero que sí existe la eternidad…Os amo.…Amar antes de nacer y echar de menos algo que nunca tuve…¡Que los números te guíen hacia tu verdadero yo ! <br><br>Doina Ro",
    image: "/images/blog1.jpg"
  }
];

const BlogDetail = () => {
  const { id } = useParams();
  const post = blogPosts.find(p => p.id === id);

  const [comments, setComments] = useState([]);
  const [form, setForm] = useState({ comment: "" });
  const [replyTo, setReplyTo] = useState(null);

  // Datos del usuario guardados
  const [userInfo, setUserInfo] = useState(() => {
    const saved = localStorage.getItem("userInfo");
    return saved ? JSON.parse(saved) : { name: "", email: "" };
  });

  const [saveInfo, setSaveInfo] = useState(true);
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [id]);

  useEffect(() => {
    const saved = localStorage.getItem(`comments-${id}`);
    if (saved) setComments(JSON.parse(saved));
  }, [id]);

  useEffect(() => {
    localStorage.setItem(`comments-${id}`, JSON.stringify(comments));
  }, [comments, id]);

  if (!post) return <p>Artículo no encontrado</p>;

  const handleSubmit = (e) => {
    e.preventDefault();
    const newComment = {
      ...userInfo,
      text: form.comment,
      date: new Date().toLocaleString(),
      replies: []
    };
    setComments([...comments, newComment]);
    setForm({ comment: "" });
    if (saveInfo) {
      localStorage.setItem("userInfo", JSON.stringify(userInfo));
    } else {
      localStorage.removeItem("userInfo");
    }
  };

  const handleReplySubmit = (e, index) => {
    e.preventDefault();
    const reply = {
      ...userInfo,
      text: form.comment,
      date: new Date().toLocaleString()
    };
    const updated = [...comments];
    updated[index].replies.push(reply);
    setComments(updated);
    setForm({ comment: "" });
    setReplyTo(null);
    if (saveInfo) {
      localStorage.setItem("userInfo", JSON.stringify(userInfo));
    } else {
      localStorage.removeItem("userInfo");
    }
  };

  return (
    <section className="blog-detail">
      <h1>{post.title}</h1>
      <div className="blog-detail-container" style={{ display: "flex", gap: "2rem", alignItems: "flex-start" }}>
        <img
          src={post.image}
          alt={post.title}
          className="blog-detail-image"
          style={{
            maxWidth: "200px",
            width: "100%",
            height: "auto",
            borderRadius: "12px",
            objectFit: "cover",
          }}
        />
        <div className="blog-detail-content">
          <div dangerouslySetInnerHTML={{ __html: post.content }} />
        </div>
      </div>

      <div className="blog-comments">
        <h2>Comentarios</h2>

        {/* Formulario de comentario nuevo */}
        {replyTo === null && (
          <form onSubmit={handleSubmit} className="comment-form">
            <textarea
              placeholder="Escribe aquí..."
              value={form.comment}
              onChange={(e) => setForm({ ...form, comment: e.target.value })}
              required
            />
            <input
              type="text"
              placeholder="Nombre*"
              value={userInfo.name}
              onChange={(e) => setUserInfo({ ...userInfo, name: e.target.value })}
              required
            />
            <input
              type="email"
              placeholder="Correo electrónico*"
              value={userInfo.email}
              onChange={(e) => setUserInfo({ ...userInfo, email: e.target.value })}
              required
            />
            <div className="checkbox-container">
              <div>
              <input
                type="checkbox"
                checked={saveInfo}
                onChange={() => setSaveInfo(!saveInfo)}
              />
              </div>
             <div>
             <label>
                Guarda mi nombre y correo electrónico en este navegador para la próxima vez que comente.
              </label>
             </div>
            </div>
            <button type="submit">Enviar</button>
          </form>
        )}

        {/* Lista de comentarios */}
        <div className="comments-list">
          {comments.map((c, i) => (
            <div key={i} className="comment">
              <p>
                <strong>{c.name}</strong> ({c.date})
              </p>
              <p>{c.text}</p>

              <button onClick={() => setReplyTo(i)}>Responder</button>

              {/* Respuestas */}
              {c.replies?.map((r, j) => (
                <div key={j} className="reply">
                  <p>
                    <strong>{r.name}</strong> ({r.date})
                  </p>
                  <p>{r.text}</p>
                </div>
              ))}

              {/* Formulario de respuesta */}
              {replyTo === i && (
                <div className="reply-box">
                  <h4>
                    Responder a <span>{c.name}</span>
                    <button
                      className="cancel-reply"
                      onClick={() => setReplyTo(null)}
                    >
                      Cancelar respuesta
                    </button>
                  </h4>
                  <form onSubmit={(e) => handleReplySubmit(e, i)}>
                    <textarea
                      placeholder="Escribe aquí..."
                      value={form.comment}
                      onChange={(e) =>
                        setForm({ ...form, comment: e.target.value })
                      }
                      required
                    />
                    <input
                      type="text"
                      placeholder="Nombre*"
                      value={userInfo.name}
                      onChange={(e) =>
                        setUserInfo({ ...userInfo, name: e.target.value })
                      }
                      required
                    />
                    <input
                      type="email"
                      placeholder="Correo electrónico*"
                      value={userInfo.email}
                      onChange={(e) =>
                        setUserInfo({ ...userInfo, email: e.target.value })
                      }
                      required
                    />
                    <button type="submit">Enviar respuesta</button>
                  </form>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogDetail;